import * as ContextMenu from "@radix-ui/react-context-menu";
import { IconUserShare } from "@tabler/icons-react";
import type { ReactNode } from "react";

import menuStyles from "@/components/core/FileManager/components/FileManagerContextMenu/FileManagerContextMenu.module.scss";

import styles from "./FilesHub.module.scss";

interface ShareableCardProps {
  onShare: () => void;
  label?: string;
  children: ReactNode;
}

export function ShareableCard({
  onShare,
  label = "Share with people...",
  children,
}: ShareableCardProps) {
  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger asChild>
        <div className={styles.cardMenuTrigger}>{children}</div>
      </ContextMenu.Trigger>
      <ContextMenu.Portal>
        <ContextMenu.Content className={menuStyles.content}>
          <ContextMenu.Item className={menuStyles.item} onSelect={onShare}>
            <IconUserShare size={16} />
            {label}
          </ContextMenu.Item>
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>
  );
}
